import { render, staticRenderFns } from "./AddModelPlugin.vue?vue&type=template&id=4182bed7&scoped=true"
import script from "./AddModelPlugin.vue?vue&type=script&lang=ts"
export * from "./AddModelPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AddModelPlugin.vue?vue&type=style&index=0&id=4182bed7&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4182bed7",
  null
  ,true
)

export default component.exports